import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import constants from '../../../core/constants';

interface CustomLabelProps {
  size?: number;
  children: ReactNode;
}

const Wrapper = styled.div<{
  size?: number;
}>`
  font-family: Lato;
  font-size: ${(props) => props.size}px;
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    font-size: 12px;
  }
`;

const CustomLabel = ({ size, children }: CustomLabelProps) => (
  <Wrapper size={size}>{children}</Wrapper>
);

CustomLabel.defaultProps = {
  size: 14
};

export default CustomLabel;
